document.addEventListener("DOMContentLoaded", function() {
	const observer = new MutationObserver(function(mutationsList, observer) {
		const minicartContainer = document.querySelector('.minicart__container');
		
		if (minicartContainer) {
			minicartContainer.setAttribute("role", "dialog");
			minicartContainer.setAttribute("aria-label", "minicart");
			
			observer.disconnect();
		}
	});
	
	observer.observe(document.body, { childList: true, subtree: true });
});